export default __webpack_public_path__ + "static/media/products_services.dd47a478.svg";